import {useContext, useState} from "react";
import {Actions} from "../../Reducer/reducer";
import {CredentialsContext} from "../../API/CredentialsContext";
const ResultList = ({items}) => (<table className="table">
    <thead>
    <tr>
        <th>Tag</th>
        <th>Vehicle</th>
        <th>Status</th>
        <th>Vehicle Class</th>
        <th>Issued At</th>
        <th>Issued By</th>
    </tr>
    </thead>
    <tbody>
        {items.map((entry, idx) => (<tr key={idx}>
            <td>{entry.tag}</td>
            <td>{entry.vehicle}</td>
            <td>{entry.status}</td>
            <td>{entry.vehicleClass}</td>
            <td>{entry.issuedAt}</td>
            <td>{entry.issuer}</td>
        </tr>))}
    </tbody>
</table>)
const ResultError = ({error}) => (<div className={"alert alert-danger"}>{error}</div> )
const ShowResult = ({entries, success, error}) => {
    if(success === true) {
      return  <ResultList items={entries} />
    } else if(success === false){
       return <ResultError error={error} />
    } else {
       return <div className={"alert alert-info"}>No Search is Performed</div>
    }
}
export default function () {
    const {dispatch} = useContext(CredentialsContext)
    const [state, setState] = useState({
        query: '',
        type: 'vehicle',
        result: {
            status: null,
            error: '',
            entries: []
        }
    })
    const searchTag = async (e) => {
        e?.preventDefault()
        console.log('searchTag', state)
        await searchApi({query: state.query, type: state.type})
    }
    const setSearchType = (e) => {
        setState(prev => ({...prev, type: e.target.value}))
    }
    const setSearchValue = (e) => {
        setState(prev => ({...prev, query: e.target.value}))
    }
    const searchName = state.type === 'tag' ? 'FasTag ID': 'Vehicle Number';
    const ERROR_RESULT = {status: false,error: 'Error In Making API Call', entries: []};
    const searchApi = async ({query, type}) => {
        try {
            dispatch({ type: Actions.ShowLoading })
            const payload = new FormData()
            payload.append("query", query.trim())
            payload.append("type", type)

            const url = `https://prod-1.e-waybill.in/api/fastag/search`
            const response = await fetch(url, {
                method: 'POST',
                body: payload
            })

            if (response.ok) {
                const data = await response.json()
                setState(prev => ({...prev, result: data}))
                console.log("data", data)
            } else {
                console.error("Error in getting response from update/consolidate api")
                setState(prev => ({...prev, result: ERROR_RESULT}))
            }
        } catch (error) {
            console.error("Unable to update", error)
            setState(prev => ({...prev, result: ERROR_RESULT}))
        } finally { dispatch({ type: Actions.HideLoading }) }
    }
    return (<div className={"p-3"}>
        <div className="row">
            <div className="col-3">
                <h2 className={"mb-3"}>Search Fastag</h2>
                <form onSubmit={searchTag}>
                    <div className={"form-group mb-3"}>
                        <label className={"form-label"}>Search By</label>
                        <select className={"form-control form-select"}
                                required={true}
                                value={state.type} onChange={setSearchType}>
                            <option value={"tag"}>FasTag</option>
                            <option value={"vehicle"}>Vehicle Number</option>
                        </select>
                    </div>
                    <div className={"form-group mb-3"}>
                        <label className={"form-label"}>
                        Enter {searchName}
                        </label>
                        <input type={"text"}
                               required={true}
                               className={"form-control"} onChange={setSearchValue} value={state.query} />
                    </div>
                    <button className={"btn btn-success"} type={"submit"}>Search</button>
                </form>
            </div>
            <div className="col-9">
                <h2 className={"mb-3"}>Results</h2>
                <ShowResult entries={state.result?.entries} success={state.result.success} error={state.result.error}/>
            </div>
        </div>
    </div>)
}